module.exports = __webpack_public_path__ + "img/artsy-follow-us-32x32-a.dd67e3ad.png";